import React from 'react'

const SOLUTIONS = [
    {
        title: "Discover What We\n Offer",
        image: "/assets/images/about/discover.png",
        button: "Explore Services",
        buttonUrl: "/esg-trainings",
        isDownloadable: false
    },
    {
        title: "Get Detailed\n Overview",
        image: "/assets/images/about/detailed-overview.png",
        button: "Download Broucher",
        buttonUrl: "/assets/nirantara.pdf",
        isDownloadable: true
    },
    {
        title: "Experience Innovation in\n Sustainability",
        image: "/assets/images/about/exp-innovation.png",
        button: "Explore ESG Tech",
        buttonUrl: "/vajra",
        isDownloadable: false
    },
]

function ExploreSol() {
    return (
        <section className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem]  montserrat bg-[#FFF]">
            <h2 className="text-center text-3xl sm:text-4xl font-extrabold text-[#1A1A1A] my-4 sm:my-10">
                Explore Our Solutions to Drive<br /> Sustainable Growth.
            </h2>
            <div className="grid gap-3 pr-0 md:gap-[7rem] md:grid-cols-3 sm:grid-cols-1">
                {SOLUTIONS?.map((item, i) => (
                    <div
                        key={i}
                        className={`flex flex-col items-center gap-4 px-4 py-10`}
                    >
                        <div className="flex items-center justify-center p-4 text-white bg-orange-500 rounded-[8px] rounded-tr-[40px]">
                            <img src={item.image} alt={item.title} className='w-[40px] h-[40px]' />
                        </div>
                        <div>
                            <h3 className="mb-1 text-lg font-semibold text-center text-gray-800 whitespace-pre-line">
                                {item.title}
                            </h3>
                            <a
                                href={item.buttonUrl}
                                {...(item.isDownloadable ? { download: true } : {})}
                                onClick={(e) => {
                                    if (!item.isDownloadable) {
                                        e.preventDefault();
                                        window.location.href = item.buttonUrl;
                                    }
                                }}
                                className="bg-[#FFF] cursor-pointer border-2 border-[#1C486B] rounded-[8px] py-3 px-4 font-[600] flex flex-row justify-center items-center gap-2 text-[#1C486B] mx-auto mt-4"
                            >
                                {item.button}
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default ExploreSol